import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ settings }) {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--border)] mt-12 px-6 md:px-12 lg:px-24 py-14 max-w-7xl mx-auto"
    >
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif-display text-2xl">
            Ibiza <span className="text-[#C5A059]">Poolside</span> Villa
          </div>
          <p className="text-[#A1A4B5] mt-4 text-sm leading-relaxed max-w-sm">
            An exclusive Mediterranean-inspired retreat designed for discerning
            travelers who value privacy, craftsmanship and golden-hour magic.
          </p>
        </div>
        <div>
          <p className="overline mb-4">Visit</p>
          <p className="text-sm text-[#A1A4B5]">{settings?.location}</p>
          <p className="text-sm text-[#A1A4B5] mt-1">{settings?.contact_phone}</p>
          <p className="text-sm text-[#A1A4B5] mt-1">{settings?.contact_email}</p>
        </div>
        <div>
          <p className="overline mb-4">Hours</p>
          <p className="text-sm text-[#A1A4B5]">Concierge · 24 / 7</p>
          <p className="text-sm text-[#A1A4B5] mt-1">Overnight Use · 2 PM – 10 AM (next day)</p>
          <p className="text-sm text-[#A1A4B5] mt-1">Day Use · 9 AM – 5 PM (Mon–Thu)</p>
          <p className="text-sm text-[#A1A4B5] mt-1">Night Use · 7 PM – 8 AM (Mon–Thu)</p>
        </div>
      </div>
      <div className="border-t border-[var(--border)] mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#A1A4B5]">
        <span>© {new Date().getFullYear()} Ibiza Poolside Villa Resort. All rights reserved.</span>
        <Link to="/admin/login" className="luxury-link" data-testid="footer-admin-link">
          Admin Portal
        </Link>
      </div>
    </footer>
  );
}
